export const AutenticationType = {Database: 1, ActiveDirectory: 2 }